import { useCallback } from 'react';

import { useConfirmPopup } from 'src/services/popup';
import { CONFIRM_POPUP_MODE } from 'src/components/ConfirmPopup';

export const useSavePersonaDifferentLanguagePopup = () => {
  const confirmPopup = useConfirmPopup();

  return useCallback(() => {
    return confirmPopup({
      mode: CONFIRM_POPUP_MODE.confirmation,
      title: `Target audience language doesn't match brand voice`,
      content: 'To save this target audience, create a brand voice in the same language.',
      buttons: {
        confirm: 'Create brand voice',
        cancel: 'Close',
      },
      withReject: true,
    })
      .then(() => true)
      .catch(() => false);
  }, [confirmPopup]);
};
